import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import BankIcon from "../../assets/images/bank7.png";
import MoneyIcon from "../../assets/images/moneyPiker7.png";
import map from "../../assets/images/map7.png";
import WalletIcon from "../../assets/images/Wallet7.png";
import IconBackArrow from "../../assets/images/IconBackArrow.png";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import InputBase from "@material-ui/core/InputBase";
import transitions from "@material-ui/core/styles/transitions";
import { TransferContext } from "../../context/TransferContext";
import RefreshToken from "../../components/RefreshToken";
import { AuthContext } from "../../context/AuthContext";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "20px",
  },

  rightAlign: {
    textAlign: "right",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  backButton: {
    fontSize: "16px",
    textTransform: "capitalize",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },

  // custom by Rubel
  box_wrapper: {
    display: "flex",
    // alignItems: "space-between",
    justifyContent: "space-between",
  },
  box: {
    padding: 30,
    width: "31%",
    borderRadius: 15,
    border: "2px solid rgba(0, 147, 80, 0.0)",
    cursor: "pointer",
  },
  box_img: {
    marginBottom: 15,
  },
  box_text: {
    fontSize: "1.3rem",
  },
  card: {
    borderRadius: 7,
    boxShadow: "0px 0px 0px #ddd",
    // padding: 22,
  },
  green: {
    background: "#EEFDF0",

    "&:hover": {
      border: "2px solid rgba(0, 147, 80, 0.7)",
    },
  },
  greenActive: {
    border: "2px solid rgba(0, 147, 80, 1)",
  },
  purple: {
    background: "#EFEFF9",
    "&:hover": {
      border: "2px solid #4B4192",
    },
  },
  purpleActive: {
    border: "2px solid #4B4192",
  },
  orange: {
    background: "#FEF1ED",
    "&:hover": {
      border: "2px solid #FF7B56",
    },
  },
  orangeActive: {
    border: "2px solid #FF7B56",
  },
  bottom_wrapper: {
    marginTop: 30,
  },
  map: {
    textAlign: "center",
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderColor: "red",
    },
    padding: "5px",
    height: 45,
    borderRadius: 7,
  },
  select_wrapper: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#9c3836",
    },
  },
  title: {
    marginBottom: 20,
  },
}));

const TransferMoney = () => {
  const classes = useStyles();
  let history = useHistory();
  const { transfer, addToTransfer } = useContext(TransferContext);

  const [countryId, setCountryId] = useState("na");
  const [loading, setLoading] = useState(false);

  const [collectionPoint, setCollectionPoint] = useState("");
  const [active, setActive] = useState("");

  const [mfsPoint, setMfsPoint] = useState([]);
  const [bankPoint, setBankPoint] = useState([]);

  const [countries, setCountries] = useState(
    transfer.countries && transfer.countries
  );
  const [documents, setDocuments] = useState([]);

  // const [fromCountry, setFromCountry] = useState({})
  // const [toCountry, setToCountry] = useState({})

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);

  // const handleCountryChange = (event) => {
  //   setCountry(event.target.value);
  // };
  const fnMoneyDeposite = () => {
    setActive("/money-deposited");
    setCollectionPoint("BANK");
  };

  const fnMoneyTransfer = () => {
    setActive("/money-transfer");
    setCollectionPoint("MFS");
  };
  const fnMoneyPicked = () => {
    setActive("/money-picked");
    setCollectionPoint("AGENT");
  };
  const redirectToPage = () => {
    let data = {
      countryId,
      collectionPoint,
    };

    addToTransfer(data);

    if (active) {
      history.push(active);
    }
  };

  const handleCountry = async (e) => {
    setLoading(true);
    let id = e.target.value;
    setCountryId(id);
    try {
      let mfs = await axios({
        url: `/api/v1/private/country/${id}/mfs`,
      });

      let bank = await axios({
        url: `/api/v1/private/country/${id}/bank`,
      });

      setMfsPoint(mfs.data.data);
      setBankPoint(bank.data.data);

      const toCountry = countries.filter((event) => event.id === id);

      console.log("to country", toCountry);

      if (!transfer.toCountry) {
        addToTransfer({ toCountry: toCountry[0] });
        addToTransfer({ fromCountry: toCountry[0] });
        addToTransfer({ rate: 1 });
        addToTransfer({ fromCurrency: toCountry[0].currency });
        addToTransfer({ toCurrency: toCountry[0].currency });
      }

      console.log("mfs", mfs.data.data);
      console.log("bank", bank.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  const getCountries = async () => {
    setLoading(true);
    try {
      let res = await axios({
        url: "/api/v1/public/countries",
        method: "get",
      });

      setCountries(res.data.data);
      addToTransfer({ countries: res.data.data });
      addToTransfer({ amountReceivable: parseInt(0) });
      addToTransfer({ amountToTransfer: parseInt(0) });
      addToTransfer({ sendAmount: parseInt(0) });
      addToTransfer({ rate: parseInt(0) });

      console.log("ccc", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  const getDocument = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let res = await axios({
        url: "/api/v1/private/document",
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setDocuments(res.data.data);
      addToTransfer({ documents: res.data.data });

      console.log("document", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!transfer.countries) {
      getDocument();
      getCountries();
    }
  }, []);

  return (
    <>
      {loading ? <LinearProgress /> : null}
      <div className={classes.root}>
        <Card className={classes.card}>
          <CardContent style={{ paddingBottom: "4px" }}>
            <Grid container>
              <Grid item md={5} className={classes.bottom_wrapper}>
                <Typography variant="h5" className={classes.title}>
                  Transfer Money to
                </Typography>
                <TextField
                  className={classes.select_wrapper}
                  id="outlined-select-currency"
                  displayEmpty
                  select
                  required
                  onChange={handleCountry}
                  variant="outlined"
                  fullWidth
                  defaultValue="na"
                  value={countryId}
                  InputProps={{
                    className: classes.select,
                  }}
                >
                  <MenuItem value="na" disabled>
                    Select a Country
                  </MenuItem>
                  {transfer.countries &&
                    transfer.countries.map((item, index) => (
                      <MenuItem value={item.id} key={index}>
                        {item.name}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item md={7} className={classes.bottom_wrapper}>
                <div className={classes.map}>
                  <img src={map} alt="map" height="160px" />
                </div>
              </Grid>
              <Grid item md={12}>
                <Typography variant="h5" className={classes.title}>
                  Select Collection Point
                </Typography>
                <div className={classes.box_wrapper}>
                  {bankPoint.length > 0 && (
                    <div
                      className={` ${classes.box} ${classes.green} ${
                        active === "/money-deposited" && classes.greenActive
                      }`}
                      onClick={fnMoneyDeposite}
                    >
                      <img src={BankIcon} alt="" className={classes.box_img} />
                      <Typography variant="h6">
                        Money Deposited to <br /> Bank Account{" "}
                      </Typography>
                    </div>
                  )}
                  {mfsPoint.length > 0 && (
                    <div
                      className={` ${classes.box} ${classes.purple} ${
                        active === "/money-transfer" && classes.purpleActive
                      } `}
                      onClick={fnMoneyTransfer}
                    >
                      <img
                        src={WalletIcon}
                        alt=""
                        className={classes.box_img}
                      />
                      <Typography variant="h6">
                        Money Transferred to <br /> MFS
                      </Typography>
                    </div>
                  )}
                  <div
                    className={` ${classes.box} ${classes.orange} ${
                      active === "/money-picked" && classes.orangeActive
                    } `}
                    onClick={fnMoneyPicked}
                  >
                    <img src={MoneyIcon} alt="" className={classes.box_img} />
                    <Typography variant="h6">
                      Money Picked Up <br /> In Person
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
      <div>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={6}>
            <Button
              className={classes.backButton}
              startIcon={<img src={IconBackArrow} alt="" />}
              disableRipple={true}
              onClick={() => window.history.back()}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={6} className={classes.rightAlign}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              onClick={redirectToPage}
              disabled={!countryId || !active}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default TransferMoney;
